function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React__default from 'react';
import Conditional from '../../misc/Conditional/index.js';
import Tooltip from '../../Tooltip/index.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var FieldBase = function FieldBase(_ref) {
  var label = _ref.label,
    name = _ref.name,
    children = _ref.children,
    required = _ref.required,
    invalid = _ref.invalid,
    errorMessage = _ref.errorMessage,
    optional = _ref.optional,
    tooltipConfig = _ref.tooltipConfig;
  return /* @__PURE__ */React__default.createElement("div", {
    className: "iq-field-base"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-field-base__label-holder"
  }, !!label ? /* @__PURE__ */React__default.createElement("label", {
    className: "iq-field-base__label",
    htmlFor: name
  }, label, !!required ? /* @__PURE__ */React__default.createElement("span", {
    className: "iq-field-base__required"
  }, " *") : !!optional ? /* @__PURE__ */React__default.createElement("span", {
    className: "iq-field-base__optional"
  }, " (Opcional)") : null) : null, !!tooltipConfig ? /* @__PURE__ */React__default.createElement(Tooltip, __spreadValues({}, tooltipConfig)) : null), /* @__PURE__ */React__default.createElement("div", {
    className: "iq-field-base__input-holder"
  }, children), /* @__PURE__ */React__default.createElement(Conditional, {
    condition: !!invalid && !!errorMessage,
    renderIf: /* @__PURE__ */React__default.createElement("p", {
      className: "iq-field-base__error-message"
    }, errorMessage)
  }));
};
export { FieldBase as default };